<template>
  <v-container
    id="users"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-human-male-female"
      inline
      class="px-5 py-3"
      top-actions
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Users
        </div>
      </template>

      <template v-slot:top-actions>
        <v-btn
          class="px-2 ml-1"
          color="success"
          @click="gotoNew()"
        >
          New user
        </v-btn>
        <debounce-v-btn
          class="px-2 ml-1 v-btn--tight"
          color="info"
          @click="refreshUsers()"
        >
          Refresh
        </debounce-v-btn>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Search"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="users"
        :search.sync="search"
        :sort-desc="[false, false]"
        multi-sort
        class="row-action"
      >
        <template v-slot:item="{ item }">
          <tr @click="gotoDetails(item)">
            <td class="text-right">
              <v-btn
                class="px-2 ml-1"
                color="warning"
                rounded
                small
                @click="gotoDetails(item)"
              >
                Edit
              </v-btn>
            </td>
            <td>{{ getResellerName(item.resellerUid) }}</td>
            <td>{{ item.firstName }}</td>
            <td>{{ item.lastName }}</td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      headers: [
        {
          sortable: false,
          text: '',
          width: '1%',
        },
        {
          sortable: true,
          text: 'Reseller',
          value: 'resellerUid',
        },
        {
          sortable: true,
          text: 'Name',
          value: 'name',
        },
        {
          sortable: true,
          text: 'Last Name',
          value: 'lastName',
        },
      ],
      search: '',
    }),
    computed: {
      ...mapGetters(['getResellerName']),
      users () {
        return this.$store.state.users.list
      },
    },
    created: async function () {
      // check depended store items are ready
      if (this.$store.state.resellers.list.length === 0) {
        await this.$store.dispatch('RefreshResellers')
      }
      if (this.$store.state.users.list.length === 0) {
        this.refreshUsers()
      }
    },
    methods: {
      async refreshUsers () {
        this.$store.dispatch('RefreshUsers', this.$t('Components.Forms.UserDetails.Messages.UsersLoadingMessage'))
      },
      gotoDetails (item) {
        this.$router.push({ name: 'User', params: { userUid: item.uid } })
      },
      gotoNew () {
        this.$router.push({ name: 'User' })
      },
    },
  }
</script>
